// 'use client';

// import { useState, useEffect, useCallback } from 'react';
// import { useMiniCart } from '@/app/context/MiniCartContext';
// import MiniCartPopup from '@/app/product/MiniCartPopup';

// interface AddToCartButtonInListProps {
//     productId: string;
//     productName: string;
//     productImage: string;
//     productPrice: number;
//     maxQuantity: number;
//     initialQty?: number;
//     stock?: boolean;
// }

// const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// export default function AddToCartButtonInList({
//     productId,
//     productName,
//     productImage,
//     productPrice,
//     maxQuantity,
//     initialQty = 1,
//     stock = true,
// }: AddToCartButtonInListProps) {
//     const [loading, setLoading] = useState(false);
//     const { setLastAddedItem, clearLastAddedItem } = useMiniCart();
//     const [isPopupOpen, setIsPopupOpen] = useState(false);
//     const [addedQuantity, setAddedQuantity] = useState(initialQty);

//     // Закрытие Popup
//     const closePopup = useCallback(() => {
//         setIsPopupOpen(false);
//         clearLastAddedItem();
//     }, [clearLastAddedItem]);

//     // Основная логика добавления в корзину
//     const addToCart = async () => {
//         if (!stock) return;

//         setLoading(true);

//         try {
//             const fetchPromise = fetch('/api/cart/add', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     productId,
//                     productName,
//                     productImage,
//                     productPrice,
//                     maxQuantity,
//                     quantity: initialQty,
//                 }),
//             });

//             const delayPromise = delay(300); // Задержка для имитации реальной загрузки (1000 мс)

//             const [response] = await Promise.all([fetchPromise, delayPromise]);

//             if (!response.ok) {
//                 throw new Error('Ошибка при добавлении в корзину');
//             }

//             // Обновляем контекст с информацией о добавленном товаре
//             setLastAddedItem({
//                 productId,
//                 productName,
//                 productImage,
//                 productPrice,
//                 quantity: initialQty,
//             });

//             setAddedQuantity(initialQty);
//             setIsPopupOpen(true);
//             console.log(`${productName} добавлен в корзину`);
//         } catch (error) {
//             console.error(error);
//             // Можно добавить уведомление об ошибке
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Закрытие popup при нажатии клавиши Esc
//     useEffect(() => {
//         const handleKeyDown = (e: KeyboardEvent) => {
//             if (e.key === 'Escape' && isPopupOpen) {
//                 closePopup();
//             }
//         };

//         window.addEventListener('keydown', handleKeyDown);

//         return () => {
//             window.removeEventListener('keydown', handleKeyDown);
//         };
//     }, [isPopupOpen, closePopup]);

//     return (
//         <>
//             <div
//                 className={`add_to_cart product_item__add_to_cart ${!stock ? 'disabled' : ''}`}
//                 onClick={stock && !loading ? addToCart : undefined}
//                 style={{ cursor: stock && !loading ? 'pointer' : 'not-allowed' }}
//             >
//                 <img
//                     src="https://nuxt.vitaline.uz/wp-content/uploads/2024/12/shopping-cart_icon-icons.com_72552-1-1.svg"
//                     alt="Корзина"
//                 />
//                 <span>{loading ? 'Добавление...' : 'В корзину'}</span>
//             </div>

//             {/* Popup */}
//             {isPopupOpen && (
//                 <MiniCartPopup
//                     productImage={productImage}
//                     productName={productName}
//                     quantity={addedQuantity}
//                     onClose={closePopup}
//                 />
//             )}
//         </>
//     );
// }



'use client';

import { useState, useEffect, useCallback } from 'react';
import { useMiniCart } from '@/app/context/MiniCartContext';
import MiniCartPopup from '@/app/product/MiniCartPopup';
import { addToCart as addToLocalStorage } from '@/app/utils/cartStorage';

// Константа для переключения между двойным хранением и только localStorage
const USE_COOKIES = true; // true - двойное хранение (cookies + localStorage), false - только localStorage

interface AddToCartButtonInListProps {
    productId: string;
    productName: string;
    productImage: string;
    productPrice: number;
    maxQuantity: number;
    initialQty?: number;
    stock?: boolean;
}

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export default function AddToCartButtonInList({
    productId,
    productName,
    productImage,
    productPrice,
    maxQuantity,
    initialQty = 1,
    stock = true,
}: AddToCartButtonInListProps) {
    const [loading, setLoading] = useState(false);
    const { setLastAddedItem, clearLastAddedItem } = useMiniCart();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [addedQuantity, setAddedQuantity] = useState(initialQty);

    const closePopup = useCallback(() => {
        setIsPopupOpen(false);
        clearLastAddedItem();
    }, [clearLastAddedItem]);

    // Функция для добавления в localStorage
    const addToLocalCart = async () => {
        const product = {
            productId,
            name: productName,
            image: productImage,
            price: productPrice,
            maxQuantity,
            quantity: initialQty,
        };

        // Добавляем в localStorage
        addToLocalStorage(product);

        // Делаем запрос к API для логирования
        await fetch('/api/cart/add-local', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(product),
        });
    };

    // Функция для добавления через cookies
    const addToCookieCart = async () => {
        const response = await fetch('/api/cart/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                productId,
                productName,
                productImage,
                productPrice,
                maxQuantity,
                quantity: initialQty,
            }),
        });

        if (!response.ok) {
            throw new Error('Ошибка при добавлении в корзину');
        }
    };

    // Основная логика добавления в корзину
    const addToCart = async () => {
        if (!stock) return;

        setLoading(true);

        try {
            const delayPromise = delay(300);

            if (USE_COOKIES) {
                // Используем оба хранилища одновременно
                await Promise.all([
                    addToCookieCart(), // Сохраняем в cookies
                    addToLocalCart(),  // Сохраняем в localStorage
                    delayPromise
                ]);
                console.log(`${productName} добавлен в корзину (cookies + localStorage)`);
            } else {
                // Используем только localStorage
                await Promise.all([
                    addToLocalCart(),
                    delayPromise
                ]);
                console.log(`${productName} добавлен в корзину (localStorage)`);
            }

            // Обновляем контекст с информацией о добавленном товаре
            setLastAddedItem({
                productId,
                productName,
                productImage,
                productPrice,
                quantity: initialQty,
            });

            setAddedQuantity(initialQty);
            setIsPopupOpen(true);
        } catch (error) {
            console.error('Ошибка при добавлении в корзину:', error);
        } finally {
            setLoading(false);
        }
    };

    // Закрытие popup при нажатии клавиши Esc
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && isPopupOpen) {
                closePopup();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isPopupOpen, closePopup]);

    return (
        <>
            <div
                className={`add_to_cart product_item__add_to_cart ${!stock ? 'disabled' : ''}`}
                onClick={stock && !loading ? addToCart : undefined}
                style={{ cursor: stock && !loading ? 'pointer' : 'not-allowed' }}
            >
                <svg style={{ width: '16px' }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path d="M2.08416 2.7512C2.22155 2.36044 2.6497 2.15503 3.04047 2.29242L3.34187 2.39838C3.95839 2.61511 4.48203 2.79919 4.89411 3.00139C5.33474 3.21759 5.71259 3.48393 5.99677 3.89979C6.27875 4.31243 6.39517 4.76515 6.4489 5.26153C6.47295 5.48373 6.48564 5.72967 6.49233 6H17.1305C18.8155 6 20.3323 6 20.7762 6.57708C21.2202 7.15417 21.0466 8.02369 20.6995 9.76275L20.1997 12.1875C19.8846 13.7164 19.727 14.4808 19.1753 14.9304C18.6236 15.38 17.8431 15.38 16.2821 15.38H10.9792C8.19028 15.38 6.79583 15.38 5.92943 14.4662C5.06302 13.5523 4.99979 12.5816 4.99979 9.64L4.99979 7.03832C4.99979 6.29837 4.99877 5.80316 4.95761 5.42295C4.91828 5.0596 4.84858 4.87818 4.75832 4.74609C4.67026 4.61723 4.53659 4.4968 4.23336 4.34802C3.91052 4.18961 3.47177 4.03406 2.80416 3.79934L2.54295 3.7075C2.15218 3.57012 1.94678 3.14197 2.08416 2.7512Z" fill="#ffffff"></path> <path d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z" fill="#ffffff"></path> <path d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z" fill="#ffffff"></path>
                    </g>
                </svg>
                <span>{loading ? 'Добавление...' : 'В корзину'}</span>
            </div>

            {isPopupOpen && (
                <MiniCartPopup
                    productImage={productImage}
                    productName={productName}
                    quantity={addedQuantity}
                    onClose={closePopup}
                />
            )}
        </>
    );
}